import { z } from 'zod';
import { MemberStatus, MemberType } from '#validation/member';
import { serviceAccountRefSchema } from '../service-account/service-account-ref';
import { userAccountRefSchema } from '../user/user-ref';
export const memberRefSchema = z.discriminatedUnion('type', [
    z.object({
        id: z.string(),
        type: z.literal(MemberType.USER),
        account: userAccountRefSchema,
        status: z.enum(MemberStatus),
    }),
    z.object({
        id: z.string(),
        type: z.literal(MemberType.SERVICE_ACCOUNT),
        account: serviceAccountRefSchema,
        status: z.enum(MemberStatus),
    }),
]);
